import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SesiImage } from "../../styles/Home";
import SESI from "../../assets/img/sesi.png";
import BACKGROUNDIMAGECREW from "../../assets/img/backgroundImageCrew.png";
import {
  ConfirmButton,
  ContractHistory,
  CrewStyle,
  DocumentsAccess,
  IconsContainer,
  IsExpandedColumn,
  LogoutButton,
  NewRegisterCard,
  NewRegisterCardWrapper,
  SearchBar,
  SearchContainer,
  SearchIcon,
  SecondColumnExpanded,
  StaticImage,
  WrapContent,
} from "../../styles/Crew";
import { FaBookBookmark } from "react-icons/fa6";
import { FaArrowLeft, FaFileAlt } from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";
import ChoosePlan from "../../components/choosePlan";
import {
  errorContract,
  getContractInfo,
  setEnterpriseId,
  setIdContract,
  setNumberContract,
} from "../../data/services/crew_service";
import { CREW_PAGE, DOCUMENTS, HISTORY } from "../../core/app-urls";
import { BackButton } from "../../styles/AddAdherense";

export default function Crew() {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [contractNumber, setContractNumber] = useState("");
  const [contractData, setContractData] = useState<any>(null);
  const [error, setError] = useState<String>("");
  const navigate = useNavigate();

  const handleExpand = async () => {
    if (!contractNumber) return;
    setIsExpanded(true);
    setError("");
    setContractData(null);

    try {
      const { contract } = await getContractInfo(contractNumber);
      setNumberContract(contractNumber);
      setIdContract(contract?.idContrato!.toString()!);
      if (contract) {
        setEnterpriseId(contract.idAssociado!.toString());
        setContractData(contract);
      } else {
        setError(errorContract);
      }
    } catch (err: any) {
      setError(err.message || "Erro ao buscar contrato.");
    }
  };

  const handleConfirm = () => {
    setIsConfirmed(true);
  };

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    navigate("/login-equipe-sesi");
  };

  return (
    <CrewStyle>
      {(isConfirmed || isExpanded) && (
        <BackButton onClick={() => window.location.reload()}>
          <FaArrowLeft />
          Voltar
        </BackButton>
      )}
      <WrapContent>
        <LogoutButton onClick={handleLogout}>
          <FiLogOut size={20} />
          Logout
        </LogoutButton>
        <StaticImage src={BACKGROUNDIMAGECREW} />
        <SesiImage src={SESI} />
        <h1>PORTAL DO CLIENTE</h1>
        <h3>EQUIPE SESI</h3>
        <NewRegisterCardWrapper>
          {!isConfirmed && (
            <NewRegisterCard isExpanded={isExpanded}>
              {isExpanded ? (
                <IsExpandedColumn>
                  <SearchContainer isExpanded={isExpanded}>
                    <SearchBar
                      placeholder="Digite o número de contrato"
                      value={contractNumber}
                      onChange={(e) => setContractNumber(e.target.value)}
                    />
                    <SearchIcon size={20} onClick={handleExpand} />
                  </SearchContainer>
                  {error && <p style={{ color: "red" }}>{error}</p>}
                  {contractData && (
                    <SecondColumnExpanded>
                      <h1>Nome: {contractData.nomeFantasia}</h1>
                      <h1>CPF/CNPJ: {contractData.cnpj}</h1>
                      <h1>Contrato: {contractData.numeroContrato}</h1>
                      <h1>Unidade: {contractData.unidade}</h1>
                    </SecondColumnExpanded>
                  )}
                </IsExpandedColumn>
              ) : (
                <>
                  <h1>Iniciar novos cadastros</h1>
                  <SearchContainer isExpanded={isExpanded}>
                    <SearchBar
                      placeholder="Número do contrato"
                      value={contractNumber}
                      onChange={(e) => setContractNumber(e.target.value)}
                    />
                    <SearchIcon size={20} onClick={handleExpand} />
                  </SearchContainer>
                </>
              )}
              {error === "" && (
                <ConfirmButton isExpanded={isExpanded} onClick={handleConfirm}>
                  Confirmar
                </ConfirmButton>
              )}
            </NewRegisterCard>
          )}
          {isConfirmed && <ChoosePlan />}
        </NewRegisterCardWrapper>
        {!isExpanded && (
          <IconsContainer>
            <ContractHistory
              onClick={() => {
                navigate(HISTORY);
              }}
            >
              <FaBookBookmark size={50} color="#005CA9" />
              <h4>Histórico de Cadastros</h4>
            </ContractHistory>

            <DocumentsAccess
              onClick={() => {
                navigate(DOCUMENTS);
              }}
            >
              <FaFileAlt size={50} color="#005CA9" />
              <h4>Documentos</h4>
            </DocumentsAccess>
          </IconsContainer>
        )}
      </WrapContent>
    </CrewStyle>
  );
}
